import * as React from "react";
import { Box, Typography } from "@mui/material";
import { ReportStatusBadge } from "./ReportStatusBadge";

interface ReportCardProps {
  name: string;
  status: string;
  description?: string;
}

/** One row in the Available Reports section: a report type's name, availability status, and why. */
export function ReportCard({ name, status, description }: ReportCardProps): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
        py: 1.5,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box>
        <Typography variant="body1">{name}</Typography>
        {description ? (
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        ) : undefined}
      </Box>
      <ReportStatusBadge status={status} />
    </Box>
  );
}
